import { render, staticRenderFns } from "./CollapsedSidebar.vue?vue&type=template&id=447fd3db"
import script from "./CollapsedSidebar.vue?vue&type=script&lang=js"
export * from "./CollapsedSidebar.vue?vue&type=script&lang=js"
import style0 from "./CollapsedSidebar.vue?vue&type=style&index=0&id=447fd3db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports